module.exports = __webpack_public_path__ + "img/idea-db-source.c4b054cf.svg";